import gql from 'graphql-tag';
import { porterDeliveryQrCodeFragment } from './fragments';

export const createConciergeOrder = gql`
  mutation createConciergeOrder(
    $condominiumPersonContextId: ID!
    $unityId: ID!
    $imageUrl: String!
    $addresseePersonContextId: ID
    $observations: String
    $trackingCode: String
    $deliveryKind: Int
  ) {
    createConciergeOrder(
      condominiumPersonContextId: $condominiumPersonContextId
      unityId: $unityId
      imageUrl: $imageUrl
      addresseePersonContextId: $addresseePersonContextId
      observations: $observations
      trackingCode: $trackingCode
      deliveryKind: $deliveryKind
    ) {
      id
    }
  }
`;

export const withdrawConciergeOrder = gql`
  mutation withdrawConciergeOrder(
    $condominiumPersonContextId: ID!
    $deliveryId: ID!
    $code: String
    $name: String
    $personContextId: Int
  ) {
    withdrawConciergeOrder(
      condominiumPersonContextId: $condominiumPersonContextId
      deliveryId: $deliveryId
      code: $code
      name: $name
      personContextId: $personContextId
    ) {
      withdrawer {
        condominiumUserId
        name
        profile
        email
      }
    }
  }
`;

export const createPorterDeliveryQrCode = gql`
  mutation createPorterDeliveryQrCode(
    $condominiumPersonContextId: ID!
    $data: PorterDeliveryQrCodeInput!
  ) {
    createPorterDeliveryQrCode(
      condominiumPersonContextId: $condominiumPersonContextId
      data: $data
    ) {
      ...porterDeliveryQrCodeParts
    }
  }
  ${porterDeliveryQrCodeFragment}
`;

export const updatePorterDeliveryEnabled = gql`
  mutation updatePorterDeliveryEnabled(
    $condominiumPersonContextId: ID!
    $enabled: Boolean!
  ) {
    updatePorterDeliveryEnabled(
      condominiumPersonContextId: $condominiumPersonContextId
      enabled: $enabled
    )
  }
`;

export const updatePorterDeliveryQrCode = gql`
  mutation updatePorterDeliveryQrCode(
    $condominiumPersonContextId: ID!
    $uuid: ID!
    $data: PorterDeliveryQrCodeInput!
  ) {
    updatePorterDeliveryQrCode(
      condominiumPersonContextId: $condominiumPersonContextId
      uuid: $uuid
      data: $data
    ) {
      ...porterDeliveryQrCodeParts
    }
  }
  ${porterDeliveryQrCodeFragment}
`;

export const deletePorterDeliveryQrCode = gql`
  mutation deletePorterDeliveryQrCode(
    $condominiumPersonContextId: ID!
    $uuid: ID!
  ) {
    deletePorterDeliveryQrCode(
      condominiumPersonContextId: $condominiumPersonContextId
      uuid: $uuid
    )
  }
`;

export const addDeliveryUnityResponsibles = gql`
  mutation addDeliveryUnityResponsibles(
    $condominiumPersonContextId: Int!
    $unityId: Int!
    $personContextIds: [Int!]!
  ) {
    addDeliveryUnityResponsibles(
      condominiumPersonContextId: $condominiumPersonContextId
      unityId: $unityId
      personContextIds: $personContextIds
    ) {
      unityId
      responsiblePersonContextIds
    }
  }
`;

export const removeDeliveryUnityResponsible = gql`
  mutation removeDeliveryUnityResponsible(
    $condominiumPersonContextId: Int!
    $unityId: Int!
    $personContextId: Int!
  ) {
    removeDeliveryUnityResponsible(
      condominiumPersonContextId: $condominiumPersonContextId
      unityId: $unityId
      personContextId: $personContextId
    )
  }
`;
